import styled from "@emotion/styled";
import { WIDGET_GEOMETRY } from "../../../iframe/widgetGeometry";

// Shared with the iframe host bridge, which has to size the iframe to exactly
// this footprint — see widgetGeometry.ts.
const { margin, bubbleSize, maxWidth, maxHeight } = WIDGET_GEOMETRY;

const ChatbotWrapper = styled.div<{
  minimizeBot: boolean;
}>`
  --chatbot-min-size: ${bubbleSize}px;
  --chatbot-width: calc(100% - ${2 * margin}px);
  --chatbot-height: calc(100% - ${2 * margin}px);
  --chatbot-max-width: ${maxWidth}px;
  --chatbot-max-height: ${maxHeight}px;

  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: ${({ minimizeBot }) =>
    minimizeBot ? "var(--chatbot-min-size)" : "var(--chatbot-width)"};
  height: ${({ minimizeBot }) =>
    minimizeBot ? "var(--chatbot-min-size)" : "var(--chatbot-height)"};
  max-width: var(--chatbot-max-width);
  max-height: var(--chatbot-max-height);
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0px;
  right: 0px;

  z-index: 99999;
  background-color: white;
  margin: ${margin}px;

  /* A11Y FIX: the window container is only focused programmatically on open
     (tabIndex=-1, never reached via Tab), so we suppress the outline that would
     otherwise draw a box around the whole widget. Interactive controls inside
     keep their default focus indicator. */
  &:focus {
    outline: none;
  }

  @media (max-width: 320px) {
    --chatbot-width: 100%;
    --chatbot-height: 100%;

    width: var(--chatbot-width);
    height: var(--chatbot-height);
    border-radius: 0;
    position: fixed;
    bottom: 0;
    right: 0;

    @keyframes fadeIn {
      from {
        width: 0;
        height: 0;
      }
      to {
        width: var(--chatbot-width);
        height: var(--chatbot-height);
      }
    }

    @keyframes fadeOut {
      from {
        width: var(--chatbot-width);
        height: var(--chatbot-height);
      }
      to {
        width: 0;
        height: 0;
      }
    }
  }
`;

export default ChatbotWrapper;
